import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import RaisedButton from 'material-ui/RaisedButton';
import { grey50 } from 'material-ui/styles/colors';

import Daypicker from './Daypicker';
import DurationSlider from './DurationSlider';
import CarTierCheckBox from './CarTierCheckBox';
import Separator from '../../shared/Separator';
import ParkingCheckBox from './ParkingCheckBox';
import StartTimeSelect from './StartTimeSelect';

import './index.css';

const FilterSideBar = ({
  certification,
  duration,
  endDate,
  getDaysInWeek,
  handleChangeDate,
  handleDurationFilter,
  handleParkinglotFilter,
  handleStartTimeFilter,
  handleTierFilter,
  openDialog,
  parkinglots,
  shifts,
  startDate,
  startTime,
  tier,
  toggleDrawer
}) => (
  <div className="sidebar">
    <button className="close-button blank-btn" onClick={toggleDrawer}>
      <FontAwesomeIcon icon={['fal', 'chevron-left']} />
    </button>
    <DurationSlider
      handleDurationFilter={handleDurationFilter}
      duration={duration}
    />
    <Separator />
    <StartTimeSelect
      shifts={shifts}
      handleStartTimeFilter={handleStartTimeFilter}
      startTime={startTime}
    />
    <Separator />
    <Daypicker
      getDaysInWeek={getDaysInWeek}
      handleChangeDate={handleChangeDate}
      startDate={startDate}
      endDate={endDate}
    />
    <Separator />
    <CarTierCheckBox
      selectedTier={tier}
      handleTierFilter={handleTierFilter}
      openDialog={openDialog}
      certification={certification}
    />
    <Separator />
    <ParkingCheckBox
      handleParkinglotFilter={handleParkinglotFilter}
      parkinglots={
        parkinglots.length > 1
          ? [parkinglots[parkinglots.length - 1]]
          : parkinglots
      }
    />
    <Separator />
    <RaisedButton
      className="apply-button"
      backgroundColor="#33691E"
      fullWidth={false}
      label="Apply"
      labelColor={grey50}
      labelStyle={{ fontFamily: 'Montserrat', fontWeight: '200' }}
      onClick={toggleDrawer}
    />
  </div>
);

export default FilterSideBar;



// WEBPACK FOOTER //
// ./src/components/Book/FilterSidebar/index.js